module.exports = __webpack_public_path__ + "static/media/logo_blue.f9621bd4.svg";